<template>
  <v-container-principal>
    <template #filter>
      <v-filtro>
        <template v-slot:bloco>
          <v-select
            v-model="selecao.bloco"
            :items="blocoNomes"
            @change="loadSalasAndUpdateURL"
            label="Todos os blocos"></v-select>
        </template>
        <template v-slot:andar>
          <v-select
            v-model="selecao.piso"
            :items="pisos"
            @change="loadSalasAndUpdateURL"
            label="Todos os pisos"></v-select>
        </template>
        <template v-slot:sala>
          <v-select
            v-model="selecao.sala"
            :items="salaNomes"
            @change="loadSalasAndUpdateURL"
            label="Todos as salas"></v-select>
        </template>
      </v-filtro>
    </template>
    <v-card class="pa-6">
      <div class="d-flex justify-end">
        <v-btn @click="relatorio" color="primary"> Imprimir </v-btn>
      </div>
      <v-data-iterator
        :items="salas"
        :options.sync="options"
        :items-per-page="footerProps.pagination.itemsPerPage"
        :server-items-length="footerProps.pagination.itemsLength"
        :footer-props="footerProps"
        :loading="loading"
        @update:page="updatePage"
        @update:items-per-page="updateItemsPerPage">
        <template v-slot:default="props">
          <v-col v-for="item in props.items" :key="item.id" cols="12">
            <template v-if="item.attributes.disponivel">
              <div class="relatorio">
                <div class="text-h5 font-weight-bold text-center">
                  {{ item.attributes.bloco.data.attributes.descricao }} -
                  {{ item.attributes.nome }}
                </div>
                <div class="font-weight-bold text-center secondary--color">
                  {{ item.attributes.capacidade }} lugares
                </div>
                <v-calendario :reservas="reservas[item.id]"></v-calendario>
              </div>
            </template>
          </v-col>
        </template>
      </v-data-iterator>
    </v-card>
  </v-container-principal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/repositoryFactory"
import VContainerPrincipal from "../../components/VContainerPrincipal"
import VCalendario from "../../components/VCalendario.vue"
import VFiltro from "../../components/VFiltro"
import VSelect from "../../components/base/VSelect"

const salaRepository = RepositoryFactory.get("sala")
const blocoRepository = RepositoryFactory.get("bloco")

const TODOS_OS_BLOCOS = "Todos os blocos"
const TODAS_AS_SALAS = "Todas as salas"
const TODOS_OS_PISOS = "Todos os pisos"

export default {
  components: {
    VContainerPrincipal,
    VFiltro,
    VSelect,
    VCalendario,
  },

  data: () => ({
    salas: [],
    reservas: [],
    blocos: [],
    delayPesquisa: null,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: Number(localStorage.getItem("salas.itemsPerPage")) || 8,
    },

    selecao: {
      sala: undefined,
      piso: undefined,
      bloco: undefined,
    },

    focus: "",
    type: "week",
    typeToLabel: {
      month: "Mês",
      week: "Semana",
      day: "Dia",
      "4day": "4 dias",
    },
  }),
  mounted() {
    this.selecao = Object.assign(this.selecao, this.$route.query)
    this.loadSalas()

    blocoRepository.getAll().then((res) => {
      this.blocos = res.data.data
    })
  },
  computed: {
    footerProps() {
      return {
        itemsPerPageText: "Itens por página",
        itemsPerPageOptions: [8, 16, 24, 32],
        pagination: {
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          pageStart: 1,
          itemsLength: null,
        },
      }
    },
    blocoNomes() {
      return [
        ...this.blocos.map((b) => b.attributes.descricao),
        TODOS_OS_BLOCOS,
      ]
    },
    salaNomes() {
      return [...this.salas.map((s) => s.attributes.nome), TODAS_AS_SALAS]
    },
    pisos() {
      let maxPisos = 0
      for (const bloco of this.blocos) {
        maxPisos = Math.max(bloco.attributes.quantidadeAndar)
      }
      return [
        ...Array.from(Array(maxPisos).keys(), (x) => x + 1),
        TODOS_OS_PISOS,
      ]
    },
  },
  methods: {
    async loadSalas({
      page = this.footerProps.pagination.page,
      itemsPerPage = this.footerProps.pagination.itemsPerPage,
    } = {}) {
      this.loading = true
      const blocoSelecionado = this.blocos.find(
        (b) => b.attributes.descricao === this.selecao.bloco
      )
      const andar =
        this.selecao.piso !== TODOS_OS_PISOS ? this.selecao.piso : undefined

      const nome =
        this.selecao.sala !== TODAS_AS_SALAS ? this.selecao.sala : undefined

      salaRepository
        .getSalasComReservas(page, itemsPerPage, {
          nome,
          andar,
          bloco: blocoSelecionado ? blocoSelecionado.id : undefined,
        })
        .then((res) => {
          this.loading = false
          this.salas = res.data.data
          this.footerProps.pagination.itemsLength =
            res.data.meta.pagination.total
          this.salas.forEach((sala) => {
            if (sala.attributes.disponivel) {
              const reservasSala = sala.attributes.reservas.data
                .filter((r) => r.attributes.status === "Confirmado")
                .map((r) =>
                  Object.assign(
                    r.attributes,
                    { responsavel: r.attributes.responsavel.data },
                    { id: r.id }
                  )
                )
              this.$set(this.reservas, sala.id, reservasSala)
            }
          })
        })
    },
    async loadSalasAndUpdateURL() {
      await this.loadSalas()
      this.$router.replace({ query: { ...this.selecao } })
    },
    updatePage(page) {
      this.loadSalas({ page })
    },
    updateItemsPerPage(itemsPerPage) {
      localStorage.setItem("salas.itemsPerPage", itemsPerPage)
      this.loadSalas({ itemsPerPage })
    },
    relatorio() {
      window.print()
    },
  },
}
</script>
<style scoped>
.text-h5 {
  color: #08468e;
}
</style>

<style>
@media print {
  ::-webkit-scrollbar {
    overflow: hidden;
    padding: 0%;
    margin: 0%;
  }
  .text-h5 {
    color: black !important;
  }
  footer {
    display: none;
  }
  .v-btn,
  .v-select,
  .v-data-footer,
  .v-icon.notranslate.mdi.mdi-filter-variant.theme--light {
    display: none;
  }
  .relatorio {
    page-break-after: always;
  }
  .v-card.v-sheet.theme--light {
    border: 2px solid red;
    border: none;
    box-shadow: none !important;
  }
}
</style>
